import episode1 from "../../images/story/episode-1.jpg";
import episode2 from "../../images/story/episode-2.jpg";
import episode3 from "../../images/story/episode-3.jpg";
import episode4 from "../../images/story/episode-4.jpg";
import episode5 from "../../images/story/episode-5.jpg";
import episode6 from "../../images/story/episode-6.jpg";
import episode7 from "../../images/story/episode-7.jpg";


const episodeData = [
  {
    img: episode1,
    title: "#01 在全球最大的地底礦山",
    text: `
      澳洲的東北部和昆士蘭州的西部有一個叫MOUNT ISA的小鎮；擁有世界上最大的地下礦坑，其深度超過1,500 m，總長度約為560 km。地底下非常潮濕，且路面條件顛簸。在這種惡劣的環境下，為了搬運人力與物力，車輛需反覆經歷上坡下坡的顛簸起伏，然而低速下坡會給汽車帶來沉重的負擔，但是LAND CRUISER卻在這個碩大的地下空間中如履平地。
      
      在潮濕的路面上以低速行駛並密集地煞車，車輛的部品很容易受到損傷。LAND CRUISER這種一般乘用車無法正常運作的環境中，滿足各種需求。
     
      在無法容許途中故障的礦坑中，因為有LAND  CRUISER，礦工能在地底下安心工作，並安全地完成工作返回地面。
    `
  },
  {
    img: episode2,
    title: "#02 在阿曼的漁村",
    text: `
      LAND CRUISER不僅具備在惡劣環境中，將人和物品安全運送到目的地的能力，
      同時也擔任豐富人們日常生活的重要角色。
      
      在中東阿曼一個漁村工作的LAND CRUISER是一個典型的例子。
      為了要勝任漁村的工作，LAND CRUISER不僅必須在鬆軟的沙灘行駛，更有許多須展現實力的機會。
      例如要將從捕魚中返回的小船拖到海灘上，或者將載有大量漁獲的水箱搬運上岸。
      
      這裡的道路凹凸起伏非常明顯。在這樣惡劣條件的道路上載重行駛，一般車輛很快就拋錨。但是對機動性超強的
      LAND CRUISER來說，這種程度的凹凸地形只是小菜一盤。此外，更同時考慮到駕駛員的舒適度，大幅減少車輛的晃動。

      讓漁獲能以新鮮的狀態送到人們的餐桌上，LAND  CRUISER對人們的幸福有著一定貢獻。
    `
  },
  {
    img: episode3,
    title: "#03 與南極探險隊同行",
    text: `
      為了觀測冰原大陸的地質與氣象，一組探險隊從日本被派遣到南極。
      雪地車擔任隊員在南極的移動與機械搬運的工作。

      而LAND CRUISER 擔任更講求機動性和行駛性能的其他工作。
      1965年，LAND CRUISER已經七次隨同探險隊前往南極。
      當地最大風速為60m/ sec，最低溫度為-45°C，環境的嚴酷難以想像。

      南極，冬天道路被深雪覆蓋，夏天地面上的岩石裸露，
      LAND CRUISER 必須展現最高水準的耐久性，才能在這兩種極端條件下行駛。

      LAND  CRUISER即使在寒冷的南極地區，也能表現出強勁的駕駛性能，
      使探險隊員可以放心地前進。
    `
  },
  {
    img: episode4,
    title: "#04 LAND CRUISER 奶奶",
    text: `
      世界上存在著環境極端惡劣，人煙稀少的地方。
      其一是位於澳洲中部沙漠入口的辛普森沙漠旅館，由一位老太太獨自經營。
      那裏土壤貧瘠，夏季溫度高於45°C，濕度低於5％。
      最近的鄰居位在100公里外，最近的加油站在200公里外。
      
      為了購買食物，必須花上兩天的車程才能抵達最近的小鎮。
      還好有LAND CRUISER，扮演老太太的腳，安全地載運她到任何目的地。

      在俯瞰360°的曠野中，老太太乘坐的LAND CRUISER在沙塵中奔馳。
      當被問及“你為什麼繼續住在這裡”時，她說：我想守護丈夫的耕地。
      而丈夫早已去世，對於獨居的祖母，LAND CRUISER扮演了重要的角色。
    `
  },
  {
    img: episode5,
    title: "#05 救生團隊神隊友",
    text: `
    LAND CRUISER ，專走沒有人走過的路。
    即使在惡劣環境，也可以展現出色的機動性以及超高的穩定度，這是許多人熱愛LAND CRUISER 的原因。
    這樣強大的工作能力，在需要展現專業能力工作場合也獲得高度的評價，
    其中，在全球各地進行救援活動是LAND CRUISER的重要任務之一。
    生命無價，救援團隊必須盡快到達目的地。

    然而在非洲大陸，許多時候道路是毀損的，或是被泥濘阻塞難以通行。
     一旦下雨，河流氾濫和道路被淹沒的情況並不少見。
    儘管如此，裝載著的醫療設備LAND CRUISER，總是能快速且安全地將患者與藥品運送到目的地。
    因為有些地方只有LAND CRUISER才能抵達，只有它才有機會為挽救生命做出貢獻。
    `
  },
  {
    img: episode6,
    title: "#06 達卡拉力的挑戰與進化",
    text: `
    只有LAND CRUISER是LAND CRUISER的對手。

    達卡拉力賽是世界上最艱難的賽車運動競賽。
    LAND CRUISER為證明自己堅不可摧的安全性和可靠性，自1995年以來，持續參加比賽。
    1995年是值得紀念的第一役。
    當時路況非常惡劣，許多載有替換零件的支援車隊都被迫離開，
    但LAND CRUISER仍以第四名的成績完成艱難的比賽。
    
    從那以後，它贏得了多次冠軍，並將參賽的經驗反饋給開發團隊，期望可以更上層樓。
    LAND CRUISER會持續挑戰達卡拉力賽，不斷進化，展現王者氣勢。
    `
  },
  {
    img: episode7,
    title: "#07 全球最受愛戴的4WD",
    text: `
    自首次亮相以來已有60多年的歷史。
    LAND CRUISER不僅是TOYOTA歷史最悠久的車系，也是受到世界上許多人愛戴的4WD車型。
    它在被沙漠覆蓋的中東地區，是主流車種，也是當地的警察和邊防人員在執行任務時，不可多得的強大坐騎。
    在需要舒適和安全的時候（例如沙漠旅行）， LAND CRUISER也能完美勝任。
    
    LAND CRUISER不僅出現在阿曼南部的小漁村，它的足跡也遍及山中偏鄉的村落，行駛在四面環山、
    漫長而陡峭泥土道路上。
    LAND CRUISER殷實地擔任村民的交通工具，並維持他們的生活，就像家庭成員一樣，是日常生活中不可或缺的一部分。
    `
  }
];

export default episodeData;